import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import toast from 'react-hot-toast';
import Button from '../components/ui/Button.jsx';
import Input from '../components/ui/Input.jsx';
import { ApiError } from '../lib/api.js';
import { loginSchema } from '../lib/schemas/auth.js';
import { useAuth } from '../context/AuthContext.jsx';
import { EVENT_DATA } from '../lib/event.js';

// Admin login page (FR-3).
// Submits to `useAuth().login()`. On 200 AuthContext handles navigation
// to /admin. On 401/429 we surface the backend message verbatim.
export default function Login() {
  const { login } = useAuth();
  const [authError, setAuthError] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: zodResolver(loginSchema),
    defaultValues: { username: '', password: '' },
    mode: 'onTouched',
  });

  const onSubmit = async (values) => {
    setAuthError(null);
    try {
      await login(values.username.trim(), values.password);
      // AuthContext navigates to /admin on success.
    } catch (err) {
      const message =
        err instanceof ApiError ? err.message : 'No pudimos iniciar sesión. Intentá de nuevo.';
      setAuthError(message);
      toast.error(message);
    }
  };

  return (
    <div className="mx-auto max-w-sm py-6">
      <h1 className="text-center font-heading text-2xl text-text">Iniciar sesión</h1>
      <p className="mt-2 text-center text-sm text-text-muted">
        Accedé al panel de administración de {EVENT_DATA.couple.display}.
      </p>

      <form onSubmit={handleSubmit(onSubmit)} className="mt-6 flex flex-col gap-4">
        <Input
          label="Usuario"
          autoComplete="username"
          {...register('username')}
          error={errors.username?.message}
        />
        <Input
          label="Contraseña"
          type="password"
          autoComplete="current-password"
          {...register('password')}
          error={errors.password?.message}
        />

        {authError && (
          <p className="text-sm text-error" role="alert">
            {authError}
          </p>
        )}

        <Button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Ingresando...' : 'Ingresar'}
        </Button>
      </form>
    </div>
  );
}